import { create } from 'zustand';
import { MasterObjectType } from 'pages/seniorMaster/schedule/types';

const daysCount = 14;

type ListState = {
  isLoaded: boolean;
  data: MasterObjectType[];
};

export type ScheduleStoreState = {
  daysCount: number;
  list: ListState;
  setList: (updater: ListState | ((prevList: ListState) => ListState)) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
  isPostInProcess: { [objectId: number]: boolean };
  setIsPostInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: { [objectId: number]: boolean }) => {
          [objectId: number]: boolean;
        })
  ) => void;
  isLoadingInProcess: { [objectId: number]: boolean };
  setIsLoadingInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: { [objectId: number]: boolean }) => {
          [objectId: number]: boolean;
        })
  ) => void;
  fromDate: { [objectId: number]: string };
  setFromDate: (
    updater:
      | { [objectId: number]: string }
      | ((prevDates: { [objectId: number]: string }) => {
          [objectId: number]: string;
        })
  ) => void;
};

const useScheduleStore = create<ScheduleStoreState>((set, get) => ({
  daysCount: daysCount,
  list: {
    isLoaded: false,
    data: [],
  },
  setList: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        list: updater(state.list),
      }));
    } else {
      set({ list: updater });
    }
  },
  isError: false,
  setIsError: (isError) => set({ isError }),
  isPostInProcess: {},
  setIsPostInProcess: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({ isPostInProcess: updater(state.isPostInProcess) }));
    } else {
      set({ isPostInProcess: updater });
    }
  },
  isLoadingInProcess: {},
  setIsLoadingInProcess: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        isLoadingInProcess: updater(state.isLoadingInProcess),
      }));
    } else {
      set({ isLoadingInProcess: updater });
    }
  },
  fromDate: {},
  setFromDate: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        fromDate: updater(state.fromDate),
      }));
    } else {
      set({ fromDate: updater });
    }
  },
}));

export default useScheduleStore;
